import { ITopology } from "../../app/apiSlice";
import moment from "moment";

interface IDateModificationTopology{
    topology: ITopology
}
const DateModificationTopology = ({topology}: IDateModificationTopology) => {
    return (
        <>
        <div style={{color:"#757575"}} key={topology.id}>
        Date de modification : {moment(topology.modificationDate).format("lll")}

        </div>
        </>
    )
}

export default DateModificationTopology;